import axios from "axios";
import * as AxiosLogger from "axios-logger";
import { Logger, getEnvProps } from "@dp/common";
var network = null;
AxiosLogger.setGlobalConfig({
  dateFormat: "HH:MM:ss",
  headers: true,
  logger: function logger(text) {
    Logger.log(text);
  }
});
export function requestInterceptorConfig(config) {
  var reqConfig = config;

  if (!reqConfig.progress || typeof reqConfig.progress !== "function") {
    reqConfig.progress = function (progressEvent) {
      // console.log(progressEvent);
      Logger.log(progressEvent);
    };
  }

  var params = config.params;
  var noTag = params === null || params === void 0 ? void 0 : params.noTag;

  if (!noTag) {
    config = network.tagRequest(config);
  }

  var env = getEnvProps();

  var __DEV__ = env.NODE_ENV === "development";

  if (__DEV__) {//AxiosLogger.requestLogger(config);
  }

  return network.beginRequest(config).then(function () {
    return config;
  });
}
export function responseInterceptorConfig(response) {
  var env = getEnvProps();

  var __DEV__ = env.NODE_ENV === "development";

  if (__DEV__) {//AxiosLogger.responseLogger(response);
  }

  return network.endRequest(response).then(function () {
    return response;
  });
}
export function responseErrorConfig(error) {
  var env = getEnvProps();

  var __DEV__ = env.NODE_ENV === "development";

  if (__DEV__) {
    AxiosLogger.errorLogger(error).then(function () {// Placeholder
    }, function () {// Placeholder
    });
    return network.errorRequest(error);
  } else {
    return network.errorRequest(error);
  }
}
export function setup(nwork) {
  network = nwork;
  axios.interceptors.request.use(requestInterceptorConfig);
  axios.interceptors.response.use(responseInterceptorConfig, responseErrorConfig);
}